import { ComponentStyleConfig } from '@chakra-ui/react';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const RadioGroup: ComponentStyleConfig = {
  parts: [
    'ButtonContainer',
    'RadioGroup',
    'RadioStack',
    'Radio',
    'RadioButton',
  ],
  baseStyle: (props: StyleFunctionProps) => ({
    ButtonContainer: {
      marginInlineStart: '0 !important',
    },
    RadioGroup: {
      display: 'flex',
      gap: 4,
    },
    RadioStack: {},
    Radio: {},
    RadioButton: {
      cursor: 'pointer',
      borderWidth: '1px',
      borderColor: mode('gray.400', 'gray.100'),
      borderRadius: 'md',
      boxShadow: 'md',
      _checked: {
        bg: 'primary',
        color: 'white',
        borderColor: 'primary',
        ...(props.variant === 'outline' && {
          bg: mode('white', 'black')(props),
          color: mode('black', 'white')(props),
        }),
      },
      _hover: {
        color: 'primary',
        _checked: { color: 'white' },
      },
      px: 5,
      py: 1,
    },
  }),
};

export default RadioGroup;
